import { ThemeComponentTypes } from '../types'

export const InputStyleOverrides: ThemeComponentTypes['MuiInput'] = {}
